export default "__VITE_ASSET__CibXEBaT__"